import { Skeleton } from '../../components/ui/skeleton';

/**
 * Каркас приложения на время первой загрузки. Повторяет раскладку Layout —
 * сайдбар, топбар, заголовок раздела, — чтобы переход к готовому экрану не
 * выглядел как подмена страницы.
 */
export function AppShellSkeleton(): JSX.Element {
  return (
    <div
      role="status"
      aria-label="Загрузка"
      className="flex h-svh w-full overflow-hidden bg-background"
    >
      <aside className="hidden w-64 shrink-0 flex-col gap-6 border-r bg-sidebar p-4 md:flex">
        <div className="flex items-center gap-3">
          <Skeleton className="size-9 rounded-lg" />
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-3.5 w-24" />
            <Skeleton className="h-2.5 w-20" />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-8 w-full rounded-md" />
          ))}
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 shrink-0 items-center gap-3 border-b px-4">
          <Skeleton className="size-7 rounded-md" />
          <Skeleton className="h-3.5 w-28" />
        </header>

        <div className="flex flex-1 flex-col gap-4 p-4 md:p-6">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-6 w-44" />
            <Skeleton className="h-3.5 w-72 max-w-full" />
          </div>
          <Skeleton className="h-9 w-full max-w-md rounded-md" />
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} className="h-24 rounded-xl" />
            ))}
          </div>
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}
